module.exports = __webpack_public_path__ + "static/media/NewsBackgroundImage.b46142ef.jpg";